import {
  AnyResponse,
  PaginationMeta,
} from "./useCursorPaginatedHistory.types";

export const pickItems = <T>(payload: AnyResponse<T>, itemsKey?: string): T[] => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data as T[];
  if (itemsKey && Array.isArray((payload as any)?.[itemsKey])) {
    return (payload as any)[itemsKey] as T[];
  }
  return [];
};

const pickPagination = <T>(
  payload: AnyResponse<T>,
): PaginationMeta | undefined => {
  if (Array.isArray(payload)) return undefined;
  return (payload?.pagination || undefined) as PaginationMeta | undefined;
};

export const pickCursor = <T>(payload: AnyResponse<T>): string | undefined => {
  if (Array.isArray(payload)) return undefined;
  const pag = pickPagination(payload);
  return (
    pag?.next_cursor ||
    pag?.nextCursor ||
    (payload?.next_cursor as string | undefined) ||
    (payload?.nextCursor as string | undefined)
  );
};

export const pickHasNext = <T>(payload: AnyResponse<T>): boolean | undefined => {
  if (Array.isArray(payload)) return undefined;
  const pag = pickPagination(payload);
  if (pag?.has_next !== undefined) return pag.has_next;
  if (pag?.hasNext !== undefined) return pag.hasNext;
  return undefined;
};

export const pickCount = <T>(payload: AnyResponse<T>): number | undefined => {
  if (Array.isArray(payload)) return undefined;
  const pag = pickPagination(payload);
  const raw = pag?.total_count ?? pag?.totalCount ?? payload?.count;
  if (raw === undefined || raw === null || raw === "") return undefined;
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
};

export const getPositionEventAction = (data: any) =>
  String(data?.action || data?.sourceAction || "").toLowerCase();

export const isClosedPositionAction = (action: string) =>
  action === "closed" ||
  action === "close" ||
  action === "position_closed" ||
  action === "liquidated" ||
  action === "liquidate";

/** Index of the page number inside a page key (see `getKey` in useCursorPaginatedHistory.hook). */
export const PAGE_INDEX_KEY_POSITION = 6;

/**
 * SWR-infinite `revalidate` predicate that refetches only the first page
 * (FE-9). A realtime event changes the head of the list; refetching every
 * loaded page per event multiplied requests by the pages a trader scrolled.
 */
export const revalidateFirstPageOnly = (_pageData: unknown, pageArg: unknown) =>
  Array.isArray(pageArg) && pageArg[PAGE_INDEX_KEY_POSITION] === 0;

